import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = 'https://tribaltech-backend.onrender.com';

export default function AffiliateLogin() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle');
  const [err, setErr]     = useState('');

  async function submit(e) {
    e.preventDefault();
    setState('sending'); setErr('');
    try {
      await axios.post(`${API}/api/affiliate/request-login`, { email });
      setState('sent');
    } catch (e) {
      setErr(e.response?.data?.error || e.message);
      setState('error');
    }
  }

  return (
    <div style={page}>
      <div style={card}>
        <div style={eyebrow}>Creator Protect · Affiliate</div>
        <h1 style={{ color:'#fff', fontSize: 24, margin:'6px 0 18px' }}>Sign in to your affiliate dashboard</h1>

        {state === 'sent' ? (
          <div style={{ padding: 16, background:'rgba(74,222,128,0.08)', border:'1px solid rgba(74,222,128,0.3)', borderRadius: 8, color:'#4ade80' }}>
            Check <strong>{email}</strong>. If we have an affiliate account on that address, a sign-in link is on its way.
          </div>
        ) : (
          <form onSubmit={submit}>
            <label style={label}>Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" disabled={state === 'sending'} style={input} />
            <button type="submit" disabled={state === 'sending'} style={button}>
              {state === 'sending' ? 'Sending…' : 'Email me a sign-in link'}
            </button>
            {err && <div style={{ color:'#f87171', fontSize: 13, marginTop: 12 }}>{err}</div>}
          </form>
        )}

        <div style={{ marginTop: 24, fontSize: 12, color:'#666', textAlign:'center' }}>
          New here? <Link to="/affiliate/join" style={{ color:'#a78bfa' }}>Join the program</Link>
        </div>
      </div>
    </div>
  );
}

const page  = { minHeight:'100vh', background:'linear-gradient(180deg, #0f0f1e 0%, #0a0a0f 100%)',
                display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 20px' };
const card  = { background:'#111', borderRadius: 16, padding: 32, maxWidth: 440, width:'100%',
                border:'1px solid #222' };
const eyebrow = { fontSize: 11, color:'#888', letterSpacing: 2, textTransform:'uppercase', marginBottom: 6 };
const label = { display:'block', fontSize: 12, color:'#94a3b8', marginBottom: 6 };
const input = { width:'100%', padding: 12, borderRadius: 8, background:'#0a0a0a',
                border:'1px solid #222', color:'#fff', fontSize: 14, boxSizing:'border-box', marginBottom: 14 };
const button= { width:'100%', padding: 14, borderRadius: 8, border:'none', background:'#7c3aed',
                color:'#fff', fontSize: 15, fontWeight: 600, cursor:'pointer' };
